import loadable from '@loadable/component';

export const OrgDashboardViewCreditPackContainerLoadable = loadable(
  () => import('./OrgDashboardViewCreditPackContainer'),
  {
    resolveComponent: (module) => module.OrgDashboardViewCreditPackContainer,
    ssr: false,
  },
);
